import api, { TipoOptions } from './api';
import { OptionProps } from '@digital/ui';

export const getAllTipoProjetoCategoria = () => api.get<any[]>('status/getAllTipoProjetoCategoria');

export const getAllCategoriaOptions = () => {
  return getAllTipoProjetoCategoria().then(Tipo =>
    (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as OptionProps)),
  );
}
